import api from 'api';
import { createSlice } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import {
  ICreatePaymentRequestData,
  IGetPaymentlistParams,
  IPaymentListItem,
} from 'interfaces/payment-interface';
import { IUploadImageRequestParam } from './organizationSlice';
import axios from 'axios';

interface IPaymentStateType {
  payments: IPaymentListItem[] | null;
  totalCount: number;
}

interface IPaymentResponse {
  receipts: IPaymentListItem[];
  record_count: number;
}

const initialState: IPaymentStateType = { payments: [], totalCount: 0 };

const paymentSlice = createSlice({
  name: 'Payment',
  initialState: initialState,
  reducers: {
    setPaymentsData: (state, { payload }: { payload: IPaymentResponse }) => {
      state.payments = [...payload.receipts];
      state.totalCount = payload.record_count;
    },
  },
});

export const createPayment =
  (payload: { request: ICreatePaymentRequestData }) => async (dispatch: Dispatch) => {
    try {
      const { request } = payload;
      const { data: responseData } = await api.post('/admin/payment/initiatePayment', {
        ...request,
      });
      return Promise.resolve(responseData?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const getPaymentsList =
  (
    payload: {
      request?: IGetPaymentlistParams;
      searchString?: string;
      offset?: number;
      limit?: number;
    },
    signal?: AbortSignal,
  ) =>
  async (dispatch: Dispatch) => {
    try {
      const { request, searchString = '', offset = 0, limit = 20 } = payload;

      // Construct the query string for offset, limit, and searchString
      const queryString = `?offset=${offset ?? 0}&limit=${limit ?? 20}${
        searchString ? `&searchString=${encodeURIComponent(searchString)}` : ''
      }`;

      // Make the API call using api.post
      const { data: responseData } = await api.post(
        `/admin/payment/billList${queryString}`,
        request,
        { signal },
      );

      // Dispatch an action to set payments data in Redux store
      dispatch(setPaymentsData(responseData?.data));

      // Return the data for potential further processing in the component
      return Promise.resolve(responseData?.data);
    } catch (error) {
      // Handle errors here
      return Promise.reject(error);
    }
  };

export const uploadPaymentMedia =
  (payload: { params: IUploadImageRequestParam }) => async (dispatch: Dispatch) => {
    try {
      const {
        params: { request, file },
      } = payload;
      const constfile = file;
      const { data: responseData } = await api.get('/admin/assets/get/payment', {
        params: { ...request },
      });
      await axios.put(`${responseData?.data?.url}`, constfile);
      return Promise.resolve(responseData?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const { setPaymentsData } = paymentSlice.actions;
export default paymentSlice.reducer;
